import React, { useEffect, useState } from "react";
import { Navigate, useParams, Link } from "react-router-dom";
import MainLayout from "../../layouts/mainLayout";
import CommercialDetailsComponent from "../../components/commercial/commercialDetailsComponent";
import Tabs from "../../utils/tabs";
import PayloadUpdater from "../../utils/payloadUpdater";
import Select from "react-select";
import FileInput from "../../components/fileInput";
import Spinner from "../../utils/spinner";
import {
  Validator,
  ValidateGroup,
  ClearValidator,
} from "../../components/validator";
import toastr from "../../utils/toastr";
import ReactTooltip from "react-tooltip";
import CustomModal from "../../utils/customModal";
import { toReadableDate, checkUserPermission } from "../../utils/utilityFunctions";
import { forEach } from "lodash";
import OffHirePeriodsComponent from "../../components/vessel/OffHirePeriodsComponent";
import CommercialService from "../../services/commercialService";

export default function CommercialDetailsPage() {
  const params = useParams();
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [commercial, setCommercial] = useState({});

  useEffect(async () => {
    await init();
  }, [params.vesselCommercialId]);

  const init = async () => {
    setLoading(true);
    const _commercial = await CommercialService.getCommercial(
      params.vesselCommercialId
    );
    setCommercial(_commercial || {});
    setLoading(false);
  };

  const tabHeaders = [
    { icon: "icon ni ni-view-grid-wd", text: "Details" },
    { icon: "icon ni ni-files", text: "Off-hire periods" },
  ];

  const tabContent = [
    <CommercialDetailsComponent commercial={commercial} callback={init} />,
    <OffHirePeriodsComponent commercial={commercial}></OffHirePeriodsComponent>,
  ];

  const _tabView = (
    <Tabs headers={tabHeaders} contents={tabContent} contentPadding="3" />
  );

  const pageActions = (
    <div className="toggle-wrap nk-block-tools-toggle">
      <a
        href="#"
        className="btn btn-icon btn-trigger toggle-expand mr-n1"
        data-target="pageMenu"
      >
        <em className="icon ni ni-menu-alt-r" />
      </a>
      <div className="toggle-expand-content" data-content="pageMenu">
        <ul className="nk-block-tools g-3">
         {checkUserPermission("commercial_edit_commercials ") &&  ( <li>
            <Link
              to={`/edit-commercial/${params.vesselCommercialId}`}
              className="btn btn-white btn-outline-light"
            >
              <em className="icon ni ni-files" />
              <span>Edit Commercial</span>
            </Link>
          </li>)}

          <li>
            <button
              onClick={() => window.history.back()}
              className="btn btn-white btn-outline-light btn-sm"
            >
              <em className="icon ni ni-arrow-left" />
              <span>Back to Commercials</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );

  return redirectUrl ? (
    <Navigate to={redirectUrl} replace={true} />
  ) : (
    <MainLayout
      title="Commercial Details"
      loading={loading}
      showFullLoader={loading}
      pageActions={pageActions}
    >
      <div className="shifted-top-tab">{_tabView}</div>
    </MainLayout>
  );
}
